export interface IDirections {
    route: Array<IDirection>;
}

export interface IDirection {
    summary: IDirectionSumary;
}

export interface IDirectionSumary {
    travelTime?: number | null;
    trafficTime?: number | null;
    distance?: number | null;
}

export const directions: Record<string, IDirections> = {
    '5903': {
        route: [
            {
                summary: {
                    travelTime: 9990,
                    trafficTime: 9990,
                    distance: 70216,
                },
            },
        ],
    },
    '5904': {
        route: [
            {
                summary: {
                    travelTime: 8990,
                    trafficTime: 8990,
                    distance: 60216,
                },
            },
        ],
    },
    '5908': {
        route: [
            {
                summary: {
                    travelTime: 79990,
                    trafficTime: 7990,
                    distance: 50216,
                },
            },
        ],
    },
    '15777': {
        route: [
            {
                summary: {
                    travelTime: 6990,
                    trafficTime: 6990,
                    distance: 40216,
                },
            },
        ],
    },
    '15805': {
        route: [
            {
                summary: {
                    travelTime: 5990,
                    trafficTime: 5990,
                    distance: 30216,
                },
            },
        ],
    },
    '116064': {
        route: [
            {
                summary: {
                    travelTime: 4990,
                    trafficTime: 4990,
                    distance: 20216,
                },
            },
        ],
    },
    '116066': {
        route: [
            {
                summary: {
                    travelTime: 3990,
                    trafficTime: 3990,
                    distance: 10216,
                },
            },
        ],
    },
};
